import styled from 'styled-components';

export const StyledDropdown = styled.div`
  padding: 0.7rem 1.5rem;
  border-radius: 5px;
  border: 1px solid
    ${(props) => (props.theme.id === 'dark' ? props.theme.accent2 : props.theme.accent4)};
  background-color: ${(props) => (props.theme.id === 'dark' ? props.theme.bg3 : props.theme.bg2)};
`;
